<div class="spinner-overlay">
  <ng-lottie [options]="lottieConfig" (animationCreated)="animationCreated($event)"></ng-lottie>
</div>